'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";


export default ['$scope', '$uibModalInstance', 'industry', 'IndustryService', 'StatusService',
    function ($scope, $modalInstance, industry, IndustryService, StatusService) {

        $scope.ok = ok;
        $scope.cancel = cancel;
        $scope.checkUniqueName = checkUniqueName;

        init();

        // region Function

        function init() {
            $scope.uniqueName = true;
            $scope.industry = angular.copy(industry);

            if (industry == null || angular.equals({}, industry) || industry.id == null) {
                $scope.title = "Создание новой отраслевой принадлежности";
            } else {
                $scope.title = "Редактирование отраслевой принадлежности \"" + $scope.industry.name + "\"";
            }

            StatusService.api.default(null, (data) => {
                if (!$scope.industry.status) {
                    $scope.industry.status = data._embedded;
                }
            });
        }

        function ok() {
            $modalInstance.close($scope.industry);
        }

        function cancel() {
            $modalInstance.dismiss();
        }

        function checkUniqueName(name) {
            if (name != null && name.trim() != "")
                IndustryService.api.isUniqueName({name: name}, {id: $scope.industry.id}, (data) => {
                    $scope.uniqueName = data._embedded;
                });
            else $scope.uniqueLogin = true;
        }

        // endregion

    }];